import { render, staticRenderFns } from "./OneSignal.vue?vue&type=template&id=002f8e89&scoped=true"
import script from "./OneSignal.vue?vue&type=script&lang=js"
export * from "./OneSignal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002f8e89",
  null
  
)

export default component.exports